module.exports = __webpack_public_path__ + "static/media/everyday_digital_newspaper.ab3d94a5.png";